import { render, staticRenderFns } from "./rule-list.vue?vue&type=template&id=4e9848e7&scoped=true"
import script from "./rule-list.vue?vue&type=script&lang=js"
export * from "./rule-list.vue?vue&type=script&lang=js"
import style0 from "./rule-list.vue?vue&type=style&index=0&id=4e9848e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9848e7",
  null
  
)

export default component.exports